import axios from 'axios';
import globalConfig, {translateError} from '../../util/globalConfig';

export function getQuizHistory(cursor) {
    return new Promise(function (resolve, reject) {
        axios.get(globalConfig.APIURL + 'v1/quiz/history?cursor=' + cursor + '&limit=100')
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
            reject(translateError(error));
        });
    });
}

export function getActiveQuiz() {
    return new Promise(function (resolve, reject) {
        axios.get(globalConfig.APIURL + 'v1/quiz/active')
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
            reject(translateError(error));
        });
    });
}

export function getQuizDetail(quizId,retryTimes) {
    let url;
    url = globalConfig.APIURL + 'v1/quiz/id/public?winners=1&quiz_id=' + quizId;
    return new Promise(function (resolve, reject) {
        axios.get(url)
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                if(retryTimes === 1) {
                    reject(translateError(error));
                }else {
                    setTimeout(() => {
                        getQuizDetail(quizId,retryTimes - 1).then(function (response) {
                            resolve(response.data);
                        }).catch(function (error) {
                            reject(translateError(error));
                        })
                    },3000);
                }
        });
    });
}

export function saveUserAnswer(answer) {
    return new Promise(function (res, re) {
        let url = globalConfig.APIURL + '/v1/quiz/answer';
        axios.post(url, answer).then(function (response) {
            res(response.data);
        }).catch(function (error) {
            re(translateError(error));
        });
    });
}
export function saveWithoutLoginAnswer(answer) {
    return new Promise(function (res, re) {
        let url = globalConfig.APIURL + '/v1/quiz/answer/public';
        axios.post(url, answer).then(function (response) {
            res(response.data);
        }).catch(function (error) {
            re(translateError(error));
        });
    });
}

export function totalParticipantCount(quizId) {
    return new Promise(function (resolve, reject) {
        axios.get(globalConfig.APIURL + 'v1/quiz/participant/counter?quiz_id='+quizId)
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
            reject(translateError(error));
        });
    });
}
export function enabled2X(quizId) {
    return new Promise(function (resolve, reject) {
        axios.get(globalConfig.APIURL + 'v1/quiz/x2entry?quiz_id='+quizId)
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
            reject(translateError(error));
        });
    });
}